import { useEffect, useState, useContext, useRef } from 'react'
import './ProcessList.css'
import formatDate, { formatDecisionName } from '../../../helpers/formatters'
import { downloader, requestMaker } from '../../../helpers/requestMaker'
import { SimpleAuthContext } from '../../../helpers/SimpleAuthProvider'
import fileImg from '../../../assets/file.webp'
import { getDecisionMakerFromEnum, getDecisionMakerFromId } from '../../../helpers/formFunctions'
import LoadingSpinner from '../../atoms/LoadingSpinner/LoadingSpinner'
import { FPagination } from '@fgnp/react'
import { getPage } from '../../../helpers/processApi'

const ProcessList = ({ endpoint, process, processType = undefined, filter = undefined }) => {
  const [dataFromFetch, setDataFromFetch] = useState({ data: [] })
  const [isLoading, setIsLoading] = useState(true)
  const [sortBy, setSortBy] = useState('createdAt')
  const [sortOrderAsc, setSortOrderAsc] = useState(true)
  const [sortedData, setSortedData] = useState()
  const [tableRows, setTableRows] = useState()
  const [activePage, setActivePage] = useState(1)
  var { user } = useContext(SimpleAuthContext)
  const containerRef = useRef()
  const tableRef = useRef()
  const [overlayVars, setOverlayVars] = useState({})

  const downloadReceipt = async (id) => {
    const result = await downloader(user, `process/${id}/GetPdf`)
    console.log('Download response:', {
      fileName: result.fileName,
      blobType: result.blob.type,
      blobSize: result.blob.size,
      fullResult: result
    })
    const url = window.URL.createObjectURL(new Blob([result.blob]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', result.fileName)
    link.click()
  }

  const handleClick = (link) => {
    window.location.href = link
  }

  const minDelay = (ms) => new Promise((res) => setTimeout(res, ms))

  useEffect(() => {
    if(process == "completed")
    {
    fetchCompletedProcessData()
    }
    else if(process == "withoutManager")
    {
    fetchWithoutManagerProcessData()
    }
    else
    {
      fetchData()
    }
  }, [activePage])

  // compute overlay position/size so the backdrop covers only the table body (cells), not the header
  const computeOverlay = () => {
    try {
      const container = containerRef.current
      const table = tableRef.current
      if (!container || !table) return
      const thead = table.querySelector('thead')
      const theadHeight = thead ? thead.offsetHeight : 0
      // offsetTop is relative to the offsetParent (container)
      const tableOffsetTop = table.offsetTop || 0
      const overlayTop = tableOffsetTop + theadHeight
      const overlayHeight = Math.max(0, table.offsetHeight - theadHeight)
      setOverlayVars({ '--list-overlay-top': overlayTop + 'px', '--list-overlay-height': overlayHeight + 'px' })
    } catch (e) {
      // ignore
    }
  }

  useEffect(() => {
    computeOverlay()
    window.addEventListener('resize', computeOverlay)
    return () => window.removeEventListener('resize', computeOverlay)
  }, [tableRef.current, containerRef.current, tableRows])

  // Recalculate overlay position when data is fetched
  useEffect(() => {
    if (isLoading === false) {
      // Use setTimeout to ensure DOM has been updated
      setTimeout(computeOverlay, 0)
    }
  }, [isLoading, dataFromFetch])

  // Initial overlay computation on mount
  useEffect(() => {
    setTimeout(computeOverlay, 100)
  }, [])
  
    const fetchData = async () => {
      var localValue = sortBy
      var ep = endpoint
      if (processType)
      {
        ep += processType
      }
        ep += ('?pageNumber=' + activePage)
        ep += ('&OrderAcending=' + sortOrderAsc)
        ep += ('&FilterOn=' + localValue)
      try {
        setIsLoading(true)
        const [data] = await Promise.all([
          requestMaker(user, 'GET', ep, localStorage.getItem('token')),
          minDelay(1000)
        ])
        if (data.internalError) console.error(data.internalError)
        else if (data.errorMessage === 'error') console.error('Backend error:', data.result?.message ?? data.result)
        else setDataFromFetch(data)
      } catch (err) {
        console.error(err)
      } finally {
        setIsLoading(false)
      }
    }

    const fetchCompletedProcessData = async () => {
      var localValue = sortBy
      var ep = endpoint
      if (processType)
      {
        ep += processType
      }
        ep +=  ('?isDeclined=' + filter.isDeclined) 
        ep += ('&pageNumber=' + activePage)
        ep += ('&OrderAcending=' + sortOrderAsc)
        ep += ('&FilterOn=' + localValue)
      try {
        setIsLoading(true)
        const [data] = await Promise.all([
          requestMaker(user, 'GET', ep, localStorage.getItem('token')),
          minDelay(1000)
        ])
        if (data.internalError) console.error(data.internalError)
        else if (data.errorMessage === 'error') console.error('Backend error:', data.result?.message ?? data.result)
        else setDataFromFetch(data)
      } catch (err) {
        console.error(err)
      } finally {
        setIsLoading(false)
      }
    }

    const fetchWithoutManagerProcessData = async () => {
      var localValue = sortBy
      var ep = endpoint
      if (processType)
      {
        ep += processType
      }
        ep +=  ('?excludeFinished=' + filter.excludeFinished) 
        ep += ('&onlyFinished=' + (filter.onlyFinished === undefined ? false : filter.onlyFinished))
        ep += ('&pageNumber=' + activePage)
        ep += ('&OrderAcending=' + sortOrderAsc)
        ep += ('&FilterOn=' + localValue)
      try {
        setIsLoading(true)
        const [data] = await Promise.all([
          requestMaker(user, 'GET', ep, localStorage.getItem('token')),
          minDelay(1000)
        ])
        if (data.internalError) console.error(data.internalError)
        else if (data.errorMessage === 'error') console.error('Backend error:', data.result?.message ?? data.result)
        else setDataFromFetch(data)
      } catch (err) {
        console.error(err)
      } finally {
        setIsLoading(false)
      }
    }

  // Behålls ifall sortering skall återimplementeras. Togs bort då paginering infördes.
  const handleSort = (e) => {
    sortBy === e ? setSortOrderAsc(!sortOrderAsc) : setSortBy(e)
  }

  useEffect(() => {
    if(process == "completed")
      {
        fetchCompletedProcessData()
      }
      else if(process == "withoutManager")
      {
        fetchWithoutManagerProcessData()
      }
      else
      {
        fetchData()
      }
      setIsLoading(true)
    }, [sortOrderAsc])
  
  useEffect(() => {
    if(process == "completed")
      {
        fetchCompletedProcessData()
      }
      else
      {
        fetchData()
      }
      setIsLoading(true)
    }, [sortOrderAsc])
    
    useEffect(() => {
    setSortOrderAsc(true)
  }, [sortBy])

  const handlePagination = (e, page) => {
    // show spinner immediately when user clicks pagination
    setIsLoading(true)
    setActivePage(page)
  }

  useEffect(() => {
    if (dataFromFetch.data.length > 0) {
      setSortedData([...Object.keys(dataFromFetch?.data)]
    )
    }
  }, [dataFromFetch])

  useEffect(() => {
    if (sortedData) {
      setTableRows(sortedData
        .filter((p) => {
          if (filter && process !== "withoutManager") {
            var filterValue
            var filterKey
            for (const key in filter) {
              if (Object.hasOwnProperty.call(filter, key)) {
                filterValue = filter[key]
                filterKey = key
              }
            }
            return (
              dataFromFetch.data[p].hasOwnProperty(filterKey) &&
              dataFromFetch.data[p][filterKey] === filterValue
            )
          }
          return true
        })
        .map((p, index) => {
          var status
          var processName
          var decisionStepName = getDecisionMakerFromId(
            dataFromFetch.data[p]?.processDecision?.pendingDecisionStep?.id
          )
          decisionStepName = formatDecisionName(decisionStepName)

          if (!dataFromFetch.data[p]?.isFinished)
            if (decisionStepName == 'Initierad av') {
              if (dataFromFetch.data[p]?.decision.length > 0) {
                status = 'Komplettering'
              } else {
                status = 'Utkast'
              }
            } else status = decisionStepName
          else if (dataFromFetch.data[p]?.isDeclined)
            status =
              'Avslagen av' +
              ' ' +
              formatDecisionName(
                getDecisionMakerFromEnum(
                  dataFromFetch.data[p]?.decision.sort((d) => d.CreatedAt)[
                    dataFromFetch.data[p]?.decision.length - 1
                  ].decisionMaker
                )
              )
          else if (dataFromFetch.data[p]?.isFinished) status = 'Klar'

          switch (dataFromFetch.data[p]?.processType) {
            case 'LeaveApplication':
              processName = 'Ledighetsansökan'
              break
            case 'Vip':
              processName = 'VIP - Value in People'
              break
            case 'Vehicle':
              processName = 'Bilansökan'
              break
            case 'Recruiting':
              processName = 'Finders Fee – Rekryteringsbonus'
              break
            case 'Overtime':
              processName = 'Övertidsansökan'
              break
            case 'SuggestionBox':
              processName = 'Förslagslåda'
              break
            case 'Bonus':
              processName = 'Certifieringsbonus'
              break
            default:
              processName = ''
          }

          const link =
            '../' +
            dataFromFetch.data[p]?.processType +
            '/' +
            process +
            '/' +
            dataFromFetch.data[p]?.id

          // Display manager or a placeholder if missing
          const managerDisplay = (() => {
            try {
              if (dataFromFetch.data[p]?.processType === 'Vip') {
                const parsed = JSON.parse(dataFromFetch.data[p].serializedData || '{}')
                return parsed?.NomineeManager || 'Saknas'
              }
            } catch (e) {
              // ignore parse errors
            }
            return dataFromFetch.data[p]?.managerEmail || 'Saknas'
          })()
          return (
            <tr key={index} onClick={() => handleClick(link)}>
              <td>{processName}</td>
              <td>{dataFromFetch.data[p]?.initiatedBy}</td>
              {(processType === 'vip' || processType === 'leaveApplication') && (
                <td>{dataFromFetch.data[p]?.delegatedInitiator}</td>
              )}
              <td>{formatDate(dataFromFetch.data[p]?.createdAt)}</td>
              <td>{dataFromFetch.data[p]?.referenceNumber}</td>
                <td className="manager-column">{managerDisplay}</td>
              {process === 'withoutManager' && (
                <>
                  <td className="narrow-column">{dataFromFetch.data[p]?.isDraft ? 'Ja' : 'Nej'}</td>
                  <td className="narrow-column">{dataFromFetch.data[p]?.isDeclined ? 'Ja' : 'Nej'}</td>
                  <td className="narrow-column">{dataFromFetch.data[p]?.isFinished ? 'Ja' : 'Nej'}</td>
                </>
              )}
              <td>
                {status}
                {status === 'Klar' && (
                  <>
                    <img
                      alt="Download file button"
                      className='downloadFileButton'
                      src={fileImg}
                      onClick={(event) => {
                        event.stopPropagation()
                        downloadReceipt(dataFromFetch.data[p]?.id)
                      }}
                    />
                  </>
                )}
              </td>
            </tr>
          )
        }))
    }
  }, [sortedData])

  // Skall sortering användas kan bortkommenterad kod tas tillbaka. 
  // Den fungerar inte till fullo men är en bit på vägen. Slutade att fungera i samband med implementering av paginering.
  // Prioriterades bort då den inte används i någon större utsträckning.
  return (
    <div className='listContainer' ref={containerRef} style={overlayVars}>
      <table className='listTable' ref={tableRef}>
        <thead className='listColumnHeader'>
          <tr>
            <th  onClick={() => handleSort('processType')} className={`${sortBy === 'processType' ? 'sorted-header' : ''
              }${sortOrderAsc ? ' asc' : ' desc'}`}
             >
              Namn
            </th>
            <th  onClick={() => handleSort('initiatedBy')} className={`${sortBy === 'initiatedBy' ? 'sorted-header' : ''
              }${sortOrderAsc ? ' asc' : ' desc'}`} >
              Skapad av
            </th>
            {(processType === 'vip' || processType === 'leaveApplication') &&
              <th  onClick={() => handleSort('delegatedInitiator')} className={`${sortBy === 'delegatedInitiator' ? 'sorted-header' : ''
                }${sortOrderAsc ? ' asc' : ' desc'}`} >
                Skapad åt
              </th>
            }
            <th  onClick={() => handleSort('createdAt')} className={`${sortBy === 'createdAt' ? 'sorted-header' : ''
              }${sortOrderAsc ? ' asc' : ' desc'}`} >
              Skapad
            </th>
         
            <th  onClick={() => handleSort('referenceNumber')} className={`${sortBy === 'referenceNumber' ? 'sorted-header' : ''
              }${sortOrderAsc ? ' asc' : ' desc'}`}  >
              Referens id
            </th>

              <th onClick={() => handleSort('manager')} className={`${sortBy === 'manager' ? 'sorted-header' : ''}${sortOrderAsc ? ' asc' : ' desc'} manager-column`}>
              Närmsta chef
            </th>
            {process === 'withoutManager' && (
              <>
                <th onClick={() => handleSort('isDraft')} className={`${sortBy === 'isDraft' ? 'sorted-header' : ''
                  }${sortOrderAsc ? ' asc' : ' desc'} narrow-column`}>
                  Utkast
                </th>
                <th onClick={() => handleSort('isDeclined')} className={`${sortBy === 'isDeclined' ? 'sorted-header' : ''
                  }${sortOrderAsc ? ' asc' : ' desc'} narrow-column`}>
                  Avslagen
                </th>
                <th onClick={() => handleSort('isFinished')} className={`${sortBy === 'isFinished' ? 'sorted-header' : ''
                  }${sortOrderAsc ? ' asc' : ' desc'} narrow-column`}>
                  Slutförd
                </th>
              </>
            )}
            <th  onClick={() => handleSort('status')} className={`${sortBy === 'status' ? 'sorted-header' : ''}${sortOrderAsc ? ' asc' : ' desc'}`} >Status</th>
          </tr>
        </thead>
        <tbody className='listBody'>
          {tableRows}
        </tbody>
      </table>
      {isLoading && (dataFromFetch.data?.length ?? 0) === 0 && (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '40px 0' }}>
          <div className='loadingSpinner'></div>
        </div>
      )}
      {isLoading && (dataFromFetch.data?.length ?? 0) > 0 && (
        <div className="list-overlay">
          <div className="list-overlay-backdrop" />
          <div className="list-overlay-spinner">
            <div className='loadingSpinner'></div>
          </div>
        </div>
      )}
      <div className='paginationContainer'>
      <FPagination
        pages={dataFromFetch.totalPages}
        activePage={activePage}
        align="center"
        onChange={(e, page) => handlePagination(e, page)}
      />
      </div>
    </div>
  )
}

export default ProcessList
